<template>
  <layout-breadcrumb-cartao
    cartaoCustom
    titulo="Relatório de Produtividade"
    :breadcrumb="bread"
    icone="file-text"
  >
    <div slot="cartao">
      <AnaliseProdutividade @download="downloadHandler"></AnaliseProdutividade>
    </div>
  </layout-breadcrumb-cartao>
</template>

<script>
import AnaliseProdutividade from "./shared/components/Abas/AnaliseProdutividade.vue";

import ProdutividadeMixin from "./shared/ProdutividadeMixin";

export default {
  mixins: [ProdutividadeMixin],
  components: {
    AnaliseProdutividade
  },
  data() {
    return {
      bread: [
        { titulo: "Início", url: "/home" },
        {
          titulo: "Relatório De Produtividade",
          url: "/relatorio-produtividade"
        }
      ]
    };
  }
};
</script>
